<template>
    <div class="head-db">
      <div class="search-box ub ub-xc">
        <div class="search-box-ic"><img src="../../images/zyy/searchicon1.png" alt=""></div>
        <input type="search" class="search-inpt ub-f1" v-model="keyword" @keyup.enter="search" placeholder="龙岩市中医院">
      </div>
     <div class="topimg">
          <img src="../../images/zyy/topbg.png" alt="">
      </div>
      <div class="topnav">
        <ul class="ubw ub-xc ub-ab bul">
          <li :class="channelId?'bli':'cur bli'"><a href="/">医院首页</a></li>
          <li :class="checkId== item.id?'cur bli':'bli'" v-for="(item, index) in navList" :key="index"  >
            <a @click="active(index)">
              {{item.name}} </a>
          </li>
        </ul>
      </div>

    </div>
</template>

<script>
    export default {
        name: 'tHead',
        data() {
            return {
                navList: [],
                channelId:this.$route.query.id,
                checkId:'',
                keyword:this.$route.query.keyword,
                url:this.$route.path,
                aid:this.$route.query.aid,
            }
        },
        mounted: function () {
            this.initData();
        },
      methods: {
        initData: async function () {
            let res = await this.$getJSON('zyyindex/mobileChannelList',{channelId: this.channelId,url:this.url,aid: this.aid});
            if (res.code == 1) {
              this.navList = res.data.navlist;
              this.checkId=res.data.checkId;
              this.channelId=res.data.checkId;
            }
        },
        active: function (e) {
          // this.$store.commit('SUBNAVZYY', 0);
          // // this.currentactive = e;
          // this.$store.commit('NAVZYY', e);
          if (e == -1) {
            this.$router.push({path: '/'});
          } else {
              this.$router.push({path: this.navList[e]['wap_url']});
          }

        },
        search:function () {
          //带参数跳转
          this.$router.push({path:'/search',query:{keyword:this.keyword}});
        }
      }
    }
</script>

<style lang="scss">
  .head-db{
    .search-box{
      margin: 0.1rem;
      height: 0.27rem;
      border-radius: 0.065rem;
      border: 1px solid #ddd;
      .search-box-ic{
        padding: 0 0.12rem;
        border-right: 1px solid #ddd;
        img{
          width: 0.15rem;
        }
      }
      .search-inpt{
        border: 0;
        padding: 0 0.1rem;
        line-height: 0.24rem;
      }
    }
    .topimg{
      margin: 0 auto;
    }
    .topnav{
      background: url("../../images/zyy/navbg1.png") no-repeat;
      ul{
        li{
          width: 0.75rem;
          text-align: center;
          height: 0.37rem;
          border-right: 1px solid #1d7ea4;
          border-bottom: 1px solid #3ba5ce;
          padding-top: 0.08rem;
          box-sizing: border-box;
          &:nth-child(5n){
            border-right: 0;
          }
          a{
            display: inline-block;
            width: 0.6rem;
            height: 0.23rem;
            color: #fff;
            font-size: 0.12rem;
            line-height: 0.24rem;
            vertical-align: top;
          }
          &.cur{
            a{

              background: url("../../images/zyy/navselbg.png") no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/layout/head.vue